<template>
    <div class="login-introduction">
        <svg class="logo" width="146" height="30" viewBox="0 0 146 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1754_13280)"><path d="M1.714 13.286v3.428m5.143-5.143v6.858M12 13.286v3.428m5.143-6.857v10.286m5.143-15.429v20.572m5.142-13.715v6.858m5.143-5.143v3.428" stroke="#2779ED" stroke-width="2.571" stroke-linecap="round" stroke-linejoin="round"/></g><path d="M45.036 21V4.2H55.14v1.968h-8.016v5.16h5.304v1.968h-5.304V21h-2.088zm16.858.288c-1.68 0-3.004-.572-3.972-1.716-.968-1.152-1.452-2.716-1.452-4.692 0-1.32.22-2.46.66-3.42.44-.96 1.064-1.7 1.872-2.22.816-.528 1.78-.792 2.892-.792 1.12 0 2.084.26 2.892.78.816.512 1.44 1.248 1.872 2.208.44.96.66 2.1.66 3.42 0 1.32-.22 2.464-.66 3.432-.44.96-1.068 1.7-1.884 2.22-.808.52-1.768.78-2.88.78zm0-1.944c1.032 0 1.84-.396 2.424-1.188.592-.8.888-1.9.888-3.3 0-1.408-.296-2.508-.888-3.3-.584-.792-1.392-1.188-2.424-1.188-1.04 0-1.852.396-2.436 1.188-.584.784-.876 1.892-.876 3.324 0 1.4.292 2.496.876 3.288.584.784 1.396 1.176 2.436 1.176zM71.416 21V8.736h2.088v1.248c.376-.52.828-.904 1.356-1.152.528-.256 1.132-.384 1.812-.384 1.488 0 2.592.452 3.312 1.356.72.896 1.08 2.276 1.08 4.14V21h-2.088v-7.416c0-1.032-.232-1.824-.696-2.376-.456-.56-1.104-.84-1.944-.84-.936 0-1.644.268-2.124.804-.472.528-.708 1.316-.708 2.364V21h-2.088zm19.563.288c-1.12 0-2.088-.276-2.904-.828-.816-.552-1.444-1.312-1.884-2.28-.44-.968-.66-2.076-.66-3.324 0-1.352.228-2.504.684-3.456.456-.96 1.092-1.692 1.908-2.196.816-.504 1.768-.756 2.856-.756.92 0 1.764.208 2.532.624.768.408 1.38 1.044 1.836 1.908.464.856.696 1.956.696 3.3 0 .192-.008.416-.024.672-.008.248-.024.504-.048.768h-8.304c.08.744.264 1.396.552 1.956.288.56.668 1 1.14 1.32.472.312 1.028.468 1.668.468.52 0 1-.092 1.44-.276a3.816 3.816 0 001.248-.852l1.224 1.368c-.456.456-1.024.836-1.704 1.14-.672.296-1.424.444-2.256.444zm-3.336-7.392h6.288c0-.696-.116-1.316-.348-1.86-.224-.552-.556-.984-.996-1.296-.44-.312-.976-.468-1.608-.468-.888 0-1.652.288-2.292.864-.632.576-.98 1.496-1.044 2.76zm15.656 7.392c-.84 0-1.484-.252-1.932-.756-.44-.504-.66-1.228-.66-2.172v-7.8h-1.992V8.736h1.992V4.68l2.088-1.008v5.064h3.024v1.824h-3.024v7.104c0 .584.1 1.012.3 1.284.208.264.532.396.972.396.56 0 1.168-.216 1.824-.648l-.24 2.04c-.36.192-.736.332-1.128.42a5.468 5.468 0 01-1.224.132zm10.357 0c-1.512 0-2.636-.448-3.372-1.344-.728-.896-1.092-2.272-1.092-4.128v-7.08h2.088v7.392c0 1.04.228 1.836.684 2.388.456.552 1.108.828 1.956.828.936 0 1.64-.268 2.112-.804.48-.536.72-1.324.72-2.364v-7.44h2.088V21h-2.088v-1.176c-.392.504-.836.876-1.332 1.116-.488.232-1.076.348-1.764.348zM123.959 21V8.736h2.088v1.608c.28-.624.664-1.096 1.152-1.416.496-.32 1.08-.48 1.752-.48.744 0 1.376.208 1.896.624l-.312 1.968a2.714 2.714 0 00-.828-.396 3.07 3.07 0 00-.924-.132c-.552 0-1.032.148-1.44.444-.408.296-.728.712-.96 1.248-.224.536-.336 1.164-.336 1.884V21h-2.088zm10.171 0V4.656l2.088-.984v9.288l3.984-4.224h2.496l-3.216 3.336L144.09 21h-2.28l-3.792-7.416-1.8 1.872V21h-2.088z" fill="#2779ED"/><defs><clipPath id="clip0_1754_13280"><path fill="#fff" transform="translate(0 3)" d="M0 0h34.286v24H0z"/></clipPath></defs></svg>
        <h2 class="motto">Türkçenin Sesini Öğren</h2>
        <p class="description">Fonetürk Türkçenin ses envanterini oluşturan <span class="description--highlight">birimlerin özelliklerini</span> ve <span class="description--highlight">IPA ile yazımını pratik etme</span> uygulamasıdır.</p>
        <div class="swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <span class="swiper-slide__img"></span>
                </div>
                <div class="swiper-slide">
                    <span class="swiper-slide__img"></span>
                </div>
                <div class="swiper-slide">
                    <span class="swiper-slide__img"></span>
                </div>
                <div class="swiper-slide">
                    <span class="swiper-slide__img"></span>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
        <div class="feature">
            <h2 class="feature__heading">{{ curFeature.heading }}</h2>
            <p class="feature__text">{{ curFeature.text }}</p>
        </div>
        <button
            class="btn-show-login-form"
            @click="$emit('showLoginForm')">
            <span class="btn-show-login-form__icon"></span>
            <span class="btn-show-login-form__text">Giriş / Üye Ol</span>
        </button>
        <span class="art-login__waveform"></span>
        <span class="art-login__waveform-mask"></span>
        <span class="art-login__light-top"></span>
    </div>
</template>
<script>
    // Library imports
    import Swiper, { Pagination, Autoplay } from 'swiper';
    import 'swiper/css';
    import 'swiper/css/autoplay';


    export default {
        data(){
            return {
                swiper: null,
                idxCurFeature: 0,
                features: [
                    {id: 1, heading: 'Pratik Modları', text: 'Türkçenin ses envanterini oluşturan fonetik birimlerin eklemleyici özelliklerini öğrenmek üzere pratikler yap.'},
                    {id: 2, heading: 'Detaylı Analitikler', text: 'Yaptığın pratik sayılarını, doğruluk oranlarını, en çok yanlış yaptığın birimleri ve her bir birimde kusursuzlaşma sürecini takip et!'},
                    {id: 3, heading: 'Online Meydan Okumalar', text: 'Diğer kullanıcılara aynı pratik için meydan okuyarak kimin daha bilgili olduğunu gösterebilirsin!'},
                    {id: 4, heading: 'Meydan Okuma Liderliği', text: 'Kazandığın meydan okumalarla liderlik tablosunda yükselebilir ve en iyi 10 öğreniciden biri olabilirsin!'},
                ],
            };
        },
        computed: {
            curFeature(){
                return this.features[this.idxCurFeature];
            },
        },
        mounted(){
            this.swiper = new Swiper('.swiper', {
                modules: [Pagination, Autoplay],
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination'
                },
                on: {
                    activeIndexChange: (swp) => {
                        this.idxCurFeature = swp.activeIndex;
                        let customWidth = 323;
                        if(swp.activeIndex == 0 && window.innerWidth < 1024){
                            document.querySelector('.feature').style = "width: 323px";
                        }
                        else{
                            document.querySelector('.feature').style = "";
                        }
                    }
                }
            });
        },
        beforeUnmount(){
            this.swiper.destroy(true);
        }
    };
</script>
<style scoped src="@/css/components/login-introduction.css"></style>